

export class RmInvoiceReportReq {
    grnId?: number;
    farmer?: number;
    grnfromDate?:Date;
    grnToDate?:Date;
    batchNum?:string;
    category?:string;

    harvestType?:String
}

export class AverageRateRmReport{
    fromDate?:any
    toDate?:any

    constructor(
        fromDate?:any,
        toDate?:any,
 
    ){
    this.fromDate = fromDate
    this.toDate = toDate

    }
}